module.exports = __webpack_public_path__ + "img/step15_a_stand_power_lock_wheels.d466a991.png";